import React from 'react';

const ResolutionBlock = ({ 
    type, // 'previous' or 'provided'
    title,
    resolutionText,
    description,
    resolvedBy,
    resolutionDate
}) => {
    return (
        <div className="resolution-block">
            {title && <div className="resolution-title">{title}</div>}
            {resolutionText && <div className="resolution-content">{resolutionText}</div>}
            {description && <div className="resolution-desc">{description}</div>}
            
            {(resolvedBy || resolutionDate) && (
                <div className="resolution-meta">
                    {resolvedBy && (
                        <div className="meta-item">
                            <div className="meta-label">Resolved By</div>
                            <div className="meta-value">{resolvedBy}</div>
                        </div>
                    )}
                    {resolutionDate && (
                        <div className="meta-item">
                            <div className="meta-label">Resolution Date</div>
                            <div className="meta-value">{resolutionDate}</div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default ResolutionBlock;
